import { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { INews } from '../../Models/News';
import React from 'react';
import { NewsService } from '../../Services';
import InfiniteScroll from 'react-infinite-scroller';

interface INewsListWidgetState {
    newsList: INews[];
    hasMore: boolean;
    isloading: boolean;
}

interface INewsListWidgetProps {
    themeId: number;
    area: string;
    homepageUrl: string;
    newsDetailPage: string;
    dictNoResultTitle: string;
    dictNoResultDescription: string;
}

export class NewsListWidget extends Component<
    INewsListWidgetProps,
    INewsListWidgetState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            newsList: [],
            hasMore: true,
            isloading: true,
        };

        this.getNewsList = this.getNewsList.bind(this);
    }
    private page: number = 0;

    async getNewsList() {
        const newsList = await NewsService.getAllNews(
            this.props.themeId ? this.props.themeId : 0,
            this.props.area,
            this.page
        );
        this.page++;
        const completeNewsList = this.state.newsList.concat(newsList);

        if (newsList && newsList.length == 0) {
            this.setState({ hasMore: false });
        }
        this.setState({ newsList: completeNewsList, isloading: false });
    }

    render() {
        return (
            <div className="container">
                <div className="row intro no-gutters">
                    <div className="col-12 col-lg-8 offset-lg-2 tiles tiles--with-state">
                        {this.state.newsList.length == 0 &&
                            !this.state.isloading && (
                                <div className="empty-state">
                                    <i className="icon-no-results"></i>
                                    <p>
                                        <b>{this.props.dictNoResultTitle}</b>
                                    </p>
                                    <p>{this.props.dictNoResultDescription}</p>
                                </div>
                            )}
                        <InfiniteScroll
                            loadMore={() => {
                                void this.getNewsList();
                            }}
                            hasMore={this.state.hasMore}
                            loader={
                                <div className="lds-ripple" key="loader">
                                    <div></div>
                                    <div></div>
                                </div>
                            }
                        >
                            <ul>
                                {this.state.newsList &&
                                    this.state.newsList.map((news, index) => {
                                        return (
                                            <li key={index}>
                                                <a
                                                    className="tile"
                                                    key={index}
                                                    href={
                                                        this.props.homepageUrl +
                                                        this.props
                                                            .newsDetailPage +
                                                        '/' +
                                                        news.id +
                                                        '-' +
                                                        news.urlTitle
                                                    }
                                                >
                                                    <div className="header">
                                                        <div className="state info">
                                                            Info
                                                        </div>
                                                        <h2>{news.title}</h2>
                                                    </div>
                                                    <p>{news.description}</p>
                                                </a>
                                            </li>
                                        );
                                    })}
                            </ul>
                        </InfiniteScroll>
                    </div>
                </div>
            </div>
        );
    }
}

WidgetHelper.register(NewsListWidget, 'news-list-widget');
